import * as React from "react";
import { observer } from "mobx-react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Alert, Alignment, Button, Classes, FormGroup, H5, Intent, Popover, Switch, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { toast } from "react-toastify";
import { ICstSped, newICstSped } from "../../model";
import { CstSelect, filterCst, renderCst } from "../utils/CstSelect";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";

@observer
export default class CstsCofins extends React.Component<{}, {}> {

    obs = observable({
        open_vincula_cst: false as boolean,
        open_edit_vincula_cst: false as boolean,
        selectCst: newICstSped(),
        rowCst: [] as any
    })

    constructor(props: any) {
        super(props);
    }

    async handleSaveCST(csts) {

        if (this.obs.selectCst.descricao == "") {
            toast.warning('Selecione um CST-COFINS!', {});
            return;
        }

        csts?.map(values => {
            delete values["descricao"]
            if (values.cod == this.obs.rowCst.cod) {
                values.vinculado = this.obs.selectCst.cod
            }
            return values
        })

        csts = csts.filter((value: any) => {
            return value["vinculado"];
        });


        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            cofins: csts,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.onClose()
    }

    async handleIgnorarCOFINS(e: boolean) {
        SpedEfdStore.obs.index_config_cst.ignorar_cofins = e

        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            ignorar_cofins: SpedEfdStore.obs.index_config_cst.ignorar_cofins,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.onClose()
    }

    onClose() {
        this.obs.open_vincula_cst = false
        this.obs.open_edit_vincula_cst = false
        this.obs.selectCst = newICstSped()
        this.obs.rowCst = []
    }

    async handleVincularCST(row: any) {
        this.obs.rowCst = row
        this.obs.open_vincula_cst = true
    }

    async handleDesvincularCST(row: any, csts: any) {
        csts?.map(values => {
            delete values["descricao"]
            if (values.cod == row.cod) {
                delete values["vinculado"]
            }
            return values
        })

        csts = csts.filter((value: any) => {
            return value["vinculado"];
        });


        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            cofins: csts,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.onClose()
    }

    render() {
        let cofinsText = this.obs.selectCst.descricao != "" ? `${this.obs.selectCst.cod} - ${this.obs.selectCst.descricao.substring(0, 50)}`
            : "Selecione um CST-COFINS";

        let labelText = <b>{"Ignorar Configuração CST - COFINS"}</b>

        let csts_cofins: ICstSped[] = [
            { "cod": "01", "descricao": "Operação Tributável com Alíquota Básica" },
            { "cod": "02", "descricao": "Operação Tributável com Alíquota Diferenciada" },
            { "cod": "03", "descricao": "Operação Tributável com Alíquota por Unidade de Medida de Produto" },
            { "cod": "04", "descricao": "Operação Tributável Monofásica - Revenda a Alíquota Zero" },
            { "cod": "05", "descricao": "Operação Tributável por Substituição Tributária" },
            { "cod": "06", "descricao": "Operação Tributável a Alíquota Zero" },
            { "cod": "07", "descricao": "Operação Isenta da Contribuição" },
            { "cod": "08", "descricao": "Operação sem Incidência da Contribuição" },
            { "cod": "09", "descricao": "Operação com Suspensão da Contribuição" },
            { "cod": "49", "descricao": "Outras Operações de Saída" }
        ]

        SpedEfdStore.obs.index_config_cst.cofins?.map(i => {
            csts_cofins = csts_cofins?.map(b => {
                if (i.cod == b.cod) {
                    b.vinculado = i.vinculado
                }
                return b
            })
        })

        let csts_cofins_select: ICstSped[] = [
            { "cod": "50", "descricao": "Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno" },
            { "cod": "51", "descricao": "Operação com Direito a Crédito – Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno" },
            { "cod": "52", "descricao": "Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação" },
            { "cod": "53", "descricao": "Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
            { "cod": "54", "descricao": "Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação" },
            { "cod": "55", "descricao": "Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação" },
            { "cod": "56", "descricao": "Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação" },
            { "cod": "60", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno" },
            { "cod": "61", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno" },
            { "cod": "62", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação" },
            { "cod": "63", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
            { "cod": "64", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação" },
            { "cod": "65", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação" },
            { "cod": "66", "descricao": "Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação" },
            { "cod": "67", "descricao": "Crédito Presumido - Outras Operações" },
            { "cod": "70", "descricao": "Operação de Aquisição sem Direito a Crédito" },
            { "cod": "71", "descricao": "Operação de Aquisição com Isenção" },
            { "cod": "72", "descricao": "Operação de Aquisição com Suspensão" },
            { "cod": "73", "descricao": "Operação de Aquisição a Alíquota Zero" },
            { "cod": "74", "descricao": "Operação de Aquisição sem Incidência da Contribuição" },
            { "cod": "75", "descricao": "Operação de Aquisição por Substituição Tributária" },
            { "cod": "98", "descricao": "Outras Operações de Entrada" },
            { "cod": "99", "descricao": "Outras Operações" }
        ]

        const textVinculado = (row) => {
            let text: string = ""

            csts_cofins_select?.map(value => {
                if (row.vinculado == value.cod) {
                    return text = `${value.cod} - ${value.descricao}`
                }
            })
            return text
        }

        const formaterVinculado = (cell, row) => {
            return (
                <>
                    {row.vinculado ?
                        <>
                            <Tooltip content={textVinculado(row)} position="right" openOnTargetFocus={false} usePortal={false}>
                                <MDBBtn color="default" rounded size="sm" onClick={() => handleEditVincularCST(row)}>
                                    <img src="/images/checked.png" width="25px" />
                                </MDBBtn>
                            </Tooltip>
                        </>
                        :
                        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleVincularCST(row)}>
                            <img src="/images/block.png" width="25px" />
                        </MDBBtn>
                    }
                </>
            );
        }

        const handleEditVincularCST = (row: any) => {
            this.obs.rowCst = row
            csts_cofins_select?.map((value: any) => { if (value.cod == row.vinculado) { return this.obs.selectCst = value } })
            this.obs.open_edit_vincula_cst = true
        }

        return (
            <>

                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_vincula_cst}
                    onClose={() => this.onClose()}
                    onConfirm={() => this.handleSaveCST(csts_cofins)}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >

                    <h2 className="titleSEFAZ">Vincule um CST - COFINS</h2>
                        <FormGroup className="empresaSelect">
                            <CstSelect
                                items={csts_cofins_select}
                                itemRenderer={renderCst}
                                itemPredicate={filterCst}
                                onItemSelect={(e: ICstSped) => this.obs.selectCst = e}
                            >
                                <Button
                                    text={cofinsText}
                                    rightIcon="double-caret-vertical"
                                    alignText={Alignment.LEFT}
                                />
                            </CstSelect>
                        </FormGroup>
                </Alert>

                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_edit_vincula_cst}
                    onClose={() => this.onClose()}
                    onConfirm={() => this.handleSaveCST(csts_cofins)}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >
                    <h2 className="titleSEFAZ">Editar CST - COFINS</h2>
                        <FormGroup className="empresaSelect">
                            <CstSelect
                                items={csts_cofins_select}
                                itemRenderer={renderCst}
                                itemPredicate={filterCst}
                                onItemSelect={(e: ICstSped) => this.obs.selectCst = e}
                            >
                                <Button
                                    text={cofinsText}
                                    rightIcon="double-caret-vertical"
                                    alignText={Alignment.LEFT}
                                />
                            </CstSelect>
                        </FormGroup>
                    <div style={{ marginTop: "50px", marginBottom: "-45px" }}>
                        <MDBBtn
                            color="danger"
                            style={{ background: "#c82333" }}
                            className="btnDefault"
                            onClick={() => this.handleDesvincularCST(this.obs.rowCst, csts_cofins)}
                        >
                            Desvincular
                        </MDBBtn>
                    </div>
                </Alert>

                <MDBCol>
                    <Switch
                        alignIndicator={Alignment.RIGHT}
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        labelElement={labelText}
                        checked={SpedEfdStore.obs.index_config_cst.ignorar_cofins}
                        onChange={(e: any) => this.handleIgnorarCOFINS(e.target.checked)}
                        style={{ marginBottom: "20px", float: "left" }}
                    />
                </MDBCol>
                {!SpedEfdStore.obs.index_config_cst.ignorar_cofins &&
                    <BootstrapTable
                        data={csts_cofins}
                    >
                        <TableHeaderColumn dataField="cod" width="1%" isKey={true} hidden >#</TableHeaderColumn>
                        <TableHeaderColumn dataField="cod" width="20%">CST</TableHeaderColumn>
                        <TableHeaderColumn dataField="descricao" width="80%">Descrição</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formaterVinculado} width="80%">Vinculado</TableHeaderColumn>
                    </BootstrapTable>
                }
            </>
        )
    }
}